import {menuSvg as Icon__small__menuSvg} from '../Icon__small/Icon__small--menu.js';

export var menu = {
  name: 'menu',
  category: 'icon',
  colorable: true,
  svg: Icon__small__menuSvg,
};
